import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryError: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBatteryError"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H20V16H23V8H20V5H1ZM20 10V14H21V10H20ZM7.08579 10L8.5 8.58579L10.5 10.5858L12.5 8.58579L13.9142 10L11.9142 12L13.9142 14L12.5 15.4142L10.5 13.4142L8.5 15.4142L7.08579 14L9.08579 12L7.08579 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryError;
